/* eslint-disable import/no-named-as-default */

import { registerSagas } from '../Action/registerSagas'
import createCheckpoints from './createCheckpoints'
import createResponse from './createResponse'
import duplicateWorkflowForContext from './duplicateWorkflowForContext'
import fetchAssignments from './fetchAssignments'
import fetchMoments from './fetchMoments'
import fetchPhaseItems from './fetchPhaseItems'
import fetchWorkflowByContext from './fetchWorkflowByContext'
import personalPanelFetchAssignments from './personalPanel/fetchAssignments'

type RegisterAllSagas = () => void

const registerAllSagas: RegisterAllSagas = () =>
  registerSagas([
    ...createCheckpoints,
    ...createResponse,
    ...personalPanelFetchAssignments,
    ...duplicateWorkflowForContext,
    ...fetchAssignments,
    ...fetchMoments,
    ...fetchPhaseItems,
    ...fetchWorkflowByContext,
  ])

export default registerAllSagas
